module.exports = __webpack_public_path__ + "static/media/featuredCoffee.c545ebe8.JPG";